import {
  doesToolSupportPromptInstruction,
  GENERATION_TOOL,
  type GenerationTool,
  isBasicGenerationTool,
  isDataDrivenGenerationTool,
  isRewriteGenerationTool,
  isSocialGenerationTool,
} from 'src/data/generationTool';

export const getBriefFormTitle = (generationTool: GenerationTool): string | undefined => {
  if (isRewriteGenerationTool(generationTool)) {
    return undefined;
  }

  switch (generationTool) {
    case GENERATION_TOOL.summarizer:
    case GENERATION_TOOL.articleBlogHeadline:
    case GENERATION_TOOL.basicContentImprover:
      return undefined;

    default:
      break;
  }

  if (doesToolSupportPromptInstruction(generationTool)) {
    return 'Prompt';
  }

  if (
    isBasicGenerationTool(generationTool) ||
    (isDataDrivenGenerationTool(generationTool) && !isSocialGenerationTool(generationTool))
  ) {
    return 'Brief';
  }

  return undefined;
};
